import React, { useContext, useEffect, useState } from "react";
import { Context } from "../context/Context";
import RemoveRoom from "./RemoveRoom";
import { CreateRoom } from "../api/api";
import SuccessToast from "./toasts/SuccessToast";
import ErrorToast from "./toasts/ErrorToast";
import RoomNameModal from "./modals/RoomNameModal";

const AddRoom = ({ rooms, setRooms }) => {
  const { setIsLoading, handleRoomNameModal } = useContext(Context);

  const [addingRoom, setAddingRoom] = useState(false);
  const [roomName, setRoomName] = useState("");

  const handleAddRoom = () => {
    handleRoomNameModal();
    // if (roomName == "" || roomName == null || !roomName) {
    //   return ErrorToast("نام اتاق را وارد کنید");
    // }
    // setIsLoading(true);
    // CreateRoom({
    //   name: roomName,
    // })
    //   .then(({ data }) => {
    //     if (roomName.trim()) {
    //       setRooms((prevRooms) => [
    //         ...prevRooms,
    //         { id: data.room.id, name: roomName }, // Assigning a unique ID
    //       ]);
    //       setRoomName("");
    //       setAddingRoom(false);
    //       SuccessToast("اتاق با موفقیت ایجاد شد");
    //     }
    //     setIsLoading(false);
    //   })
    //   .catch((err) => {});
  };

  return (
    <>
      <li className="list-group-item add-room mt-5 d-none d-lg-block me-2">
        <a className="text-secondary">
          <div
            className={addingRoom ? "d-none" : ""}
            onClick={handleAddRoom}
          >
            <i className="bx bx-plus me-1"></i>
            افزودن
          </div>
          <div className={addingRoom ? "" : "d-none"}>
            <div>
              <input
                id="smallInput"
                className="form-control form-control-sm"
                name="room_name"
                type="text"
                placeholder="نام اتاق را وارد کنید"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
              />
            </div>
            <div>
              <button
                type="button"
                className="btn btn-xs btn-success-app submit-add-room me-2"
                onClick={handleAddRoom}
              >
                ثبت
              </button>
              <button
                type="button"
                className="btn btn-xs btn-success-app"
                onClick={() => setAddingRoom(false)}
              >
                انصراف
              </button>
            </div>
          </div>
        </a>
      </li>
      <li
        className="menu-item add-room mt-2 d-lg-none me-2"
        style={{cursor: "pointer", color: "#00a594"}}
      >
        <div
          className={addingRoom ? "d-none" : "px-2"}
          onClick={() => handleRoomNameModal()}
        >
          <i className="bx bx-plus me-1" style={{fontSize: '25px'}}></i>
        </div>
        <div className={addingRoom ? "" : "d-none"}>
          <div className="row mb-2">
            <div className="col-12">
              <input
                id="smallInput"
                className="form-control form-control"
                name="room_name"
                type="text"
                placeholder="نام اتاق را وارد کنید"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              <button
                type="button"
                className="btn btn-xs btn-success-app submit-add-room w-100 p-1"
                onClick={handleAddRoom}
              >
                ثبت
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-xs btn-success-app w-100 p-1"
                onClick={() => setAddingRoom(false)}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </li>
    </>
  );
};

export default AddRoom;
